import anomalyVector from '../assets/anomaly-vector.svg';
import gpsMarker from '../assets/icons/vehicle-location-with-bg.svg';
import gpsMarkerWithRotation from '../assets/icons/vehicle-location-rotation-with-bg.svg';
import driverDrowsinessUnreadVector from '../assets/icons/dms-unread.svg';
import { ANOMALY_BG_COLOR, ANOMALY_SVG_PATH } from './constants';
import { createMarker } from './commonFunctions';

const rashDrivingMarker = {
  name: 'rash-driving',
  key: 'rash-driving-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-rash-driving-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.MAJOR,
      iconPath: ANOMALY_SVG_PATH.RASH_DRIVING,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.MAJOR_HOVER,
};
const doorOpenMarker = {
  name: 'door-open',
  key: 'door-open-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-door-open-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.MINOR,
      iconPath: ANOMALY_SVG_PATH.DOOR_OPEN,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.MINOR_HOVER,
};

const overspeedMarker = {
  name: 'overspeed',
  key: 'overspeed-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-over-speed-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.MINOR,
      iconPath: ANOMALY_SVG_PATH.OVER_SPEEDING,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.MINOR_HOVER,
};

const driverDrowsinessMarker = {
  name: 'driver-drowsiness',
  key: 'driver-drowsiness-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-driver-drowsiness-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.CRITICAL,
      iconPath: ANOMALY_SVG_PATH.DRIVER_DROWSINESS,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.CRITICAL_HOVER,
};

const driverDistractionMarker = {
  name: 'driver-distraction',
  key: 'driver-distraction-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-driver-distraction-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.CRITICAL,
      iconPath: ANOMALY_SVG_PATH.DRIVER_DROWSINESS,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.CRITICAL_HOVER,
};

const sosAlertMarker = {
  name: 'sos-alert',
  key: 'sos-alert-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-sos-vector`,
  },
  icon: {
    url: createMarker({
      backgroundColor: ANOMALY_BG_COLOR.SOS,
      iconPath: ANOMALY_SVG_PATH.SOS,
    }),
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  hoveredBackgroundColor: ANOMALY_BG_COLOR.SOS_HOVER,
};

const anomalyMarker = {
  name: 'anomaly',
  key: 'anomaly-marker',
  type: 'circle',
  position: {
    lat: 12.9393063,
    lng: 77.6095379,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-anomaly-vector`,
    icon: anomalyVector,
  },
  icon: {
    fillColor: 'red',
    fillOpacity: 1,
    strokeColor: 'red',
    strokeWeight: 2,
    scale: 20,
  },
};

const checkPointMarker = {
  name: 'actual-pickup-drop',
  key: 'check-point-marker',
  type: 'circle',
  position: {
    lat: 12.9313761,
    lng: 77.6230643,
  },
  label: {
    text: '1',
    fontFamily: 'Bosch Sans',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#232628',
  },
  icon: {
    fillColor: '#ffffff',
    fillOpacity: 1,
    strokeColor: '#ffffff',
    strokeWeight: 2,
    scale: 14,
  },
};

const actualCheckPointMarker = {
  name: 'scheduled-pickup-drop',
  key: 'check-point-marker',
  type: 'circle',
  position: {
    lat: 12.9313761,
    lng: 77.6230643,
  },
  label: {
    text: 'P1',
    fontFamily: 'Bosch Sans',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#101112',
  },
  icon: {
    fillColor: '#FFFFFF',
    fillOpacity: 1,
    strokeColor: '#4E5256',
    strokeWeight: 1,
    scale: 16,
  },
};

const gpsPointMarker = {
  name: 'current-location',
  key: 'gps-point-marker',
  type: 'svg',
  position: {
    lat: 12.9245517,
    lng: 77.6283891,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-gps-vector`,
  },
  icon: {
    url: gpsMarker,
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
};

const gpsRotationMarker = {
  name: 'current-location-with-heading',
  key: 'gps-rotation-marker',
  type: 'svg',
  position: {
    lat: 12.9245517,
    lng: 77.6283891,
  },
  label: {
    text: '',
    fontSize: '0',
    className: `custom-marker-label-gps-rotation-vector`,
  },
  icon: {
    url: gpsMarkerWithRotation,
    anchor: { x: 30, y: 30 },
    scaledSize: { x: 60, y: 60 },
  },
  heading: 0,
};

const driverDrowsinessCountMarker = {
  name: 'driver-drowsiness-count',
  key: 'driver-drowsiness-count-marker',
  type: 'circle',
  position: {
    lat: 12.9313761,
    lng: 77.6230643,
  },
  label: {
    text: '1',
    fontFamily: 'Bosch Sans',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#ffffff',
  },
  icon: {
    fillColor: '#FF2124',
    fillOpacity: 1,
    strokeColor: '#FF2124',
    strokeWeight: 2,
    scale: 14,
  },
};

const driverDrowsinessUnreadMarker = {
  name: 'driver-drowsiness-unread',
  key: 'driver-drowsiness-unread-marker',
  type: 'svg',
  position: {
    lat: 12.9336655,
    lng: 77.6177831,
  },
  label: {
    text: '',
    fontFamily: 'Bosch Sans',
    fontSize: '14px',
    fontWeight: 'bold',
    className: `custom-marker-driver-drowsiness-unread-vector`,
    color: '#ffffff',
  },
  icon: {
    url: driverDrowsinessUnreadVector,
    labelOrigin: { x: 15, y: 15 },
    anchor: { x: 15, y: 15 },
    scaledSize: { x: 30, y: 30 },
  },
};

export {
  rashDrivingMarker,
  anomalyMarker,
  checkPointMarker,
  sosAlertMarker,
  gpsPointMarker,
  gpsRotationMarker,
  actualCheckPointMarker,
  driverDistractionMarker,
  driverDrowsinessMarker,
  doorOpenMarker,
  overspeedMarker,
  driverDrowsinessCountMarker,
  driverDrowsinessUnreadMarker,
};
